import { apiClient } from '@/http/apiClient';
import { buildQuery } from '@/http/url';
const rootPath = 'countries';

class CountryService {
  
    public async getCountries(): Promise<any> {
        return apiClient.get(`${rootPath}`);
    }

    public async getCountriesByAdministrator(): Promise<any> {
        return apiClient.get(`${rootPath}/getByAdministrator`);
    }

    public async getCountryBySite(siteId:string) {
        return apiClient.get(`${rootPath}/bySite${buildQuery({siteId})}`);
    }
    
}

export default new CountryService();